import { useRef, useState } from "react";
import { ChevronsLeftRight } from "lucide-react";

export default function BeforeAfterSlider({ beforeUrl, afterUrl, title }) {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);

  const move = (clientX) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    setPos(Math.min(96, Math.max(4, ((clientX - rect.left) / rect.width) * 100)));
  };

  const onPointerDown = (e) => {
    move(e.clientX);
    const onMove = (ev) => move(ev.clientX);
    const onUp = () => {
      window.removeEventListener("pointermove", onMove);
      window.removeEventListener("pointerup", onUp);
    };
    window.addEventListener("pointermove", onMove);
    window.addEventListener("pointerup", onUp);
  };

  return (
    <figure className="gold-ring-card rounded-lg overflow-hidden" data-testid={`ba-slider-${(title || "pair").toLowerCase().replace(/[^a-z0-9]+/g, "-").slice(0, 40)}`}>
      <div
        ref={ref}
        onPointerDown={onPointerDown}
        className="relative aspect-[4/3] overflow-hidden select-none cursor-ew-resize touch-none"
      >
        <img src={afterUrl} alt={title ? `${title} — after` : "After"} draggable={false} className="absolute inset-0 w-full h-full object-cover" />
        <img
          src={beforeUrl}
          alt={title ? `${title} — before` : "Before"}
          draggable={false}
          className="absolute inset-0 w-full h-full object-cover"
          style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
        />
        <span className="absolute top-3 left-3 bg-black/60 text-white text-[10px] uppercase tracking-wider font-bold px-2.5 py-1 rounded-full">Before</span>
        <span className="absolute top-3 right-3 bg-amber-600 text-white text-[10px] uppercase tracking-wider font-bold px-2.5 py-1 rounded-full">After</span>
        <div className="absolute inset-y-0" style={{ left: `${pos}%` }}>
          <div className="absolute inset-y-0 -left-px w-0.5 bg-white shadow-[0_0_10px_rgba(0,0,0,0.5)]" />
          <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-10 h-10 rounded-full bg-white shadow-lg flex items-center justify-center">
            <ChevronsLeftRight className="w-5 h-5 text-amber-700" />
          </div>
        </div>
      </div>
      {title && <figcaption className="p-4 text-sm text-stone-700 font-medium">{title}</figcaption>}
    </figure>
  );
}
